module.exports = __webpack_public_path__ + "static/media/gaozhongIcon.8fd46e43.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gaozhongIcon.png
// module id = 654
// module chunks = 0 1